module.exports = {
  //NodeJS API
  URL_AUTH_LOGIN: "api/auth/login",
  URL_AUTH_CREATE: "api/auth/create",
  URL_AUTH_USER_EDIT: "api/auth/editUser",
  URL_AUTH_USER_DELETE: "api/auth/deleteUser",
  URL_AUTH_USER_SET_ACTIVE: "api/auth/setActiveUser",
  URL_GET_LIST_USER: "api/user/listsUser",
  URL_GET_USER_TYPE: "api/user/listsUserType",

  URL_GET_PROJECT_ADMIN: "api/project/getListsProjectAdmin",
  URL_GET_PROJECT: "api/project/getListsProject",
  URL_POST_ADD_PROJECT: "api/project/addProject",
  URL_POST_EDIT_PROJECT: "api/project/editProject",
  URL_POST_ACTIVE_PROJECT: "api/project/activeProject",
  URL_POST_DELETE_PROJECT: "api/project/deleteProject",

  //Series
  // URL_POST_SERIES_ADD : "api/series/add",
  // URL_POST_SERIES_UPDATE : "api/series/update",
  // URL_POST_SERIES_GET : "api/series/get",
  // URL_POST_SERIES_GET_ADMIN : "api/series/getForAdmin",
  // URL_POST_SERIES_ACTIVE : "api/series/active",
  // URL_POST_SERIES_DELETE : "api/series/delete",

  //Customer
  URL_GET_CUSTOMER_ALL: "api/customer/all",
  URL_GET_CUSTOMER: "api/customer/get",

  //Lead
  URL_GET_LEADUSE: "api/lead/get",
  URL_POST_LEADUSE_EXPIRED: "api/lead/getExpiredData",
  URL_POST_RAWDATA_DOWNLOAD_EXCEL_RAWDATAEXPIRED: "api/lead/getDataReportExpired",
  URL_POST_GET_DATA_LEAD_FOR_TRANFER: "api/lead/getDataLeadForTranfer",
  URL_POST_TRANFER_LEAD: "api/lead/tranferLead",

  //Sendmail
  URL_POST_SENDMAIL_EMAIL: "api/sendmail/send",

  //SendSMS
  URL_POST_SEND_SMS_SAVE_OR_SEND: "api/SMSData/sendOrSaveManuallySMS",

  URL_POST_SMS_RAW_DATA_REPORT: "api/reportSMS/get",

  //Question
  URL_POST_QUESTION_UPSERT: "api/question/upsert",
  URL_POST_QUESTION_ANSWER: "api/question/anwser",
  URL_POST_QUESTION_GET: "api/question/get",
  URL_POST_QUESTION_CONVERT_CODE_TO_ID: "api/question/codetoid",
  URL_POST_QUESTION_CONVERT_CODE_TO_ID2: "api/question/codetoid2",

  //Reports
  // URL_POST_EXPORT_EXCEL_INQUIRY_NEW : "api/exportExcel/getDataReportInquiryNew",
  // URL_POST_EXPORT_EXCEL_INQUIRY_All : "api/exportExcel/getDataReportInquiryAll",
  URL_POST_EXPORT_EXCEL_ANSWERS: "api/exportExcel/getDataReportAnswers",
  // URL_POST_EXPORT_EXCEL_FILE : "API/exportExcel/getReport",
  URL_POST_IMPORT_EXCEL_SMS_DATA_PREVIEW: "api/importExcel/smsdataPreview",
  URL_POST_IMPORT_EXCEL_SMS_DATA_APPROVE: "api/importExcel/smsdataApprove",
  URL_POST_IMPORT_EXCEL_LEAD_PREVIEW: "api/importExcelLead/saveAndPreview",
  URL_POST_IMPORT_EXCEL_LEAD_CONFIRM_IMPORT_LEAD: "api/importExcelLead/confirmImportLead",
  URL_POST_IMPORT_EXCEL_LEAD_SETTING_DATA_LIST: "api/importExcelLead/getSettingDataList",
  URL_POST_IMPORT_EXCEL_DATA_LEAD_FROM_SETTING: "api/importExcelLead/getDataFromSetting",

  URL_POST_IMPORT_EXCEL_USER: "api/importExcelUser/run",
  URL_POST_REMOVE_USER: "api/importExcelUser/removeUser",
  URL_POST_REMOVE_USER_ALL: "api/importExcelUser/removeUserAll",
  URL_POST_USER_FROM_IMPORT_GET: "api/importExcelUser/get",
  URL_POST_USER_FROM_IMPORT_DOWNLOAD: "api/importExcelUser/download",
  URL_POST_IMPORT_EXCEL_EMAIL_SAVE: "api/importMailHotAlert/saveAndPreview",
  URL_POST_EMAILHOTALERT_FROM_IMPORT_GET: "api/importMailHotAlert/get",
  URL_POST_IMPORT_QUALITY_DATA_SAVE: "api/importQualityData/saveAndPreview",
  URL_POST_QUALITY_DATA_FROM_IMPORT_GET: "api/importQualityData/get",

  URL_POST_SENDSMS_GET: "api/scheduleSendSms/getsendsms",
  URL_POST_SENDSMS_BY_ID: "api/scheduleSendSms/sendsmsById",

  URL_POST_BRANCH_CODE_TO_NAME: "api/branch/convertBranchCodeToName",

  URL_POST_RAWDATA_QUESTION_ALL: "api/rawDataQuestion/getrawdata",
  URL_POST_RAWDATA_QUESTION_BY_ID: "api/rawDataQuestion/getrawdataByid",
  URL_POST_RAWDATA_DOWNLOAD_EXCEL_RAWDATA: "api/rawDataQuestion/getDataReportRawData",

  URL_POST_SEND_MAIL_HOT_ALERT: "api/sendMailHotAlert/saveAndSendmail",

  URL_POST_SEND_MAIL_HOT_ALERT_SAVE_SATUS: "api/sendMailHotAlert/saveTagStatus",
  URL_POST_SEND_MAIL_HOT_ALERT_GET_STATUS: "api/sendMailHotAlert/getTagStatus",

  URL_POST_MAIL_HOT_ALERT_LIST_NOCHECK: "api/emailHostAlert/getList/Check",
  URL_POST_DEALER_TAG_STATUS_LIST: "api/dealerTrackStatus/get",

  URL_POST_CALL_IN_TYPE_ADMIN: "api/status/getAdmin",
  URL_POST_CALL_IN_TYPE: "api/status/get",
  URL_POST_ADD_CALL_IN_TYPE: "api/status/create",
  URL_POST_EDIT_CALL_IN_TYPE: "api/status/update",
  URL_POST_ACTIVE_CALL_IN_TYPE: "api/status/active",
  URL_POST_DELETE_CALL_IN_TYPE: "api/status/delete",

  URL_POST_CALL_IN_TYPE_SUB_1_ADMIN: "api/substatus/get",
  URL_POST_CALL_IN_TYPE_SUB_1: "api/substatus/get_by_statusid",
  URL_POST_ADD_CALL_IN_TYPE_SUB_1: "api/substatus/create",
  URL_POST_EDIT_CALL_IN_TYPE_SUB_1: "api/substatus/update",
  URL_POST_ACTIVE_CALL_IN_TYPE_SUB_1: "api/substatus/active",
  URL_POST_DELETE_CALL_IN_TYPE_SUB_1: "api/substatus/delete",
  URL_POST_GET_DEALER: "api/branch/getdealer",

  URL_POST_GET_CUSTOMERTELESURVEY: "api/customerTeleSurvey/get",
  URL_POST_GET_CUSTOMERTELESURVEY_SUCCESS_CASE: "api/customerTeleSurvey/getSuccessCase",
  URL_POST_GET_QC_CUSTOMERTELESURVEY: "api/customerTeleSurvey/qc/get",
  URL_POST_GET_QC_CUSTOMERTELESURVEY_SAVE_STATUS: "api/customerTeleSurvey/qc/saveQCStatus",
  URL_POST_GET_QC_CUSTOMERTELESURVEY_SUCCESS_CASE: "api/customerTeleSurvey/qc/getSuccessCase",
  URL_POST_GET_QC_CUSTOMERTELESURVEY_SAVE_FIXED_QC_NOTPASS: "api/customerTeleSurvey/qc/saveFixedQCNotPass",

  URL_POST_POST_SAVECALLSTATUSTELESURVEY: "api/teleSurveyHistory/saveCallHistory",
  URL_POST_POST_TELESURVEYHISTORY_GETCALLHISTORY: "api/teleSurveyHistory/getCallHistory",

  URL_POST_GET_QC_CUSTOMERTELESURVEY_SAVE_QCCANCELSTATUS: "api/customerTeleSurvey/qc/saveQCCancelStatus",

  URL_GET_GENERATEREPORTS_RUN_CLEAN_RAW_REPORT_GENERATE_AND_GET_DATA_REPORT: "api/generateReports/getRawReportGenerate/",
  URL_GET_GENERATEREPORTS_GET_CALL_CLEAN_RAW_REPORT_GENERATE: "api/generateReportsDashboard/callCleanRawReportGenerate",
  URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD1: "api/generateReportsDashboard/getDataDashboard1",
  URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD2_1L: "api/generateReportsDashboard/getDataDashboard2chart1L",
  URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD2_1L_DETAIL: "api/generateReportsDashboard/getDataDashboard2chart1LDetail",
  URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD2_1L_DETAIL_L2: "api/generateReportsDashboard/getDataDashboard2chart1LDetailL2",
  URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD2_1R: "api/generateReportsDashboard/getDataDashboard2chart1R",
  URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD2_1L2: "api/generateReportsDashboard/getDataDashboard2chart1L2",
  URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD2_1L3: "api/generateReportsDashboard/getDataDashboard2chart1L3",
  URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD2_3: "api/generateReportsDashboard/getDataDashboard2chart3",
  URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD2_4: "api/generateReportsDashboard/getDataDashboard2chart4",
  URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD3_OS1: "api/generateReportsDashboard/getDataDashboard3chart1",
  URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD3_OS2: "api/generateReportsDashboard/getDataDashboard3chart2",
  URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD3_OS3: "api/generateReportsDashboard/getDataDashboard3chart3",
  URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD3_OS4: "api/generateReportsDashboard/getDataDashboard3chart4",
  URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD3_OS4_BYDEALER: "api/generateReportsDashboard/getDataDashboard3chart4ByDealer",

  URL_GET_LANGUAGE_GET_ALLOW_LANGUAGE: "api/language/getAllowLanguage",
  URL_GET_LANGUAGE_UPDATE_ALLOW_LANGUAGE: "api/language/updateAllowLanguage",
  URL_GET_LANGUAGE_CREATE_TRANSLATE: "api/language/upsertTranslate",
  URL_GET_LANGUAGE_GET_TRANSLATE_DATA: "api/language/getTranslateData",

  URL_GET_APP_STATUS_DATA_BASE_STATUS: "api/appStatus/dataBaseStatus",

  URL_POST_SMS_DATA_IMPORT_LIST: "api/SMSData/getListImport",
  URL_POST_SMS_DATA_IMPORT_DATA: "api/SMSData/getListData",
  URL_POST_SMS_UNACTIVE_SMS: "api/SMSData/unactiveSMS",
  URL_POST_SMS_SEND_SMS_NOW: "api/SMSData/sendSMSNow",

  URL_POST_CREDIT_ADD: "api/credit/add",
  URL_POST_CREDIT_GET_CREDIT: "api/credit/getCredit",
  URL_GET_CREDIT_UPDATE_CREDIT_ITWIST: "api/credit/updateCreditItwist",
  URL_POST_CREDIT_GET_LIST_LOG: "api/credit/getListLog",
  URL_POST_CREDIT_UPDATE_SMS_FROM_EXCEL: "api/credit/updateSMSFromExcel",
  URL_POST_SEND_SMS_RECHECK_STATUS: "api/sendSms/recheckStatus",
  URL_POST_THEME_SMS_CREATE: "api/themeSMS/create",
  URL_POST_THEME_SMS_GET: "api/themeSMS/get",
  URL_POST_THEME_SMS_DELETE: "api/themeSMS/delete",
  URL_POST_THEME_SMS_ACTIVE: "api/themeSMS/active",
  URL_POST_THEME_SMS_UPDATE: "api/themeSMS/update",

  URL_POST_LOG_CLEAR_DATA_EXPIRED_AUTO_GET: "api/logClearDataExpiredAuto/get",
};